import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const UserContractService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.USER_CONTRACT, null, wait).then((data) => {
            callback(data);
        });
    },
    Save(j, callback, wait) {
        Ajax.Api(MethodType.Post, Enums.SERVICE.USER_CONTRACT, j, wait).then((data) => {
            callback(data);
        });
    },
}; 